import css from "./product.module.css";
import icon from "../../img/productPageImg.png";
import { HandySvg } from "handy-svg";
import iconSrc from "../../svg/smallProductLike.svg";
import iconSrcCard from "../../svg/smallProductCard.svg";
import audio from "../../svg/audioSvg.svg";
import arrow from "../../img/arrowToSvg.png";
import autorPic from "../../img/productAutorPic.png";
import addToCart from "../../function/addToCard";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
export default function ProductPageTitle({ oneProd }) {
  const [liked, setLiked] = useState(false);
  const [authorsList, setAuthorsList] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchAuthors = async () => {
      try {
        const authorsSnapshot = await getDocs(collection(db, "author"));

        const authors = authorsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        if (isMounted) {
          setAuthorsList(authors);
        }
      } catch (error) {
        console.error("Помилка при отриманні авторів:", error);
      }
    };

    fetchAuthors();

    return () => {
      isMounted = false;
    };
  }, []);

  const normalizeAuthorNames = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => String(item).trim()).filter(Boolean);
    }

    if (typeof value === "string" && value.trim() !== "") {
      return [value.trim()];
    }

    return [];
  };

  const findAuthorByName = (name) => {
    const surname = String(name || "")
      .trim()
      .split(" ")[0]
      ?.toLowerCase();

    if (!surname) return null;

    return authorsList.find((author) =>
      String(author.name || "")
        .toLowerCase()
        .startsWith(surname),
    );
  };

  const renderAuthorLinks = (value) => {
    const authors = normalizeAuthorNames(value);

    if (!authors.length) {
      return <span className={css.autorNameSpan}>—</span>;
    }

    return authors.map((authorName, index) => {
      const foundAuthor = findAuthorByName(authorName);

      return (
        <span key={`${authorName}-${index}`}>
          {foundAuthor?.uid ? (
            <Link
              className={css.autorNameSpan}
              to={`/author/${foundAuthor.uid}`}
            >
              {authorName}
            </Link>
          ) : (
            <span className={css.autorNameSpan}>{authorName}</span>
          )}

          {index !== authors.length - 1 && ", "}
        </span>
      );
    });
  };
  useEffect(() => {
    // Отримуємо дані з localStorage
    const likedProducts =
      JSON.parse(localStorage.getItem("likedProducts")) || [];

    // Перевіряємо, чи товар є в масиві подобається
    const isLiked = likedProducts.some(
      (product) => product.uid === oneProd.uid,
    );

    // Встановлюємо відповідний стан liked
    setLiked(isLiked);
  }, []);
  const handleLike = () => {
    // Отримуємо дані з localStorage
    let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

    if (!liked) {
      // Додаємо товар до масиву подобається

      likedProducts.push(oneProd);
    } else {
      // Видаляємо товар з масиву подобається
      const updatedLikedProducts = likedProducts.filter(
        (product) => product.uid !== oneProd.uid,
      );
      likedProducts = updatedLikedProducts;
    }

    // Зберігаємо оновлений масив у localStorage
    localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

    // Змінюємо стан liked
    setLiked(!liked);
  };

  return (
    <div className={css.productPageTitleWrap}>
      <div className={css.productPicWrap}>
        <div className={css.imgWrap}>
          <img src={oneProd.bookFoto} className={css.icon} />
        </div>
      </div>
      <div className={css.productTitleWrap}>
        <p className="autorAndHudP">
          Дітям:{" "}
          <span className="autorAndHudPSpan">
            {oneProd.yearGroup.join(", ")} років
          </span>
        </p>
        <p className="autorAndHudP">
          Унікальні читачі:{" "}
          <span className="autorAndHudPSpan">{oneProd.rating}</span>
        </p>
        <h1 className={css.nameBook}>{oneProd.bookName}</h1>
        <div className={css.wrapHud}>
          <p className={css.autor}>
            Автор:&nbsp;
            {renderAuthorLinks(oneProd.autorIdea || oneProd.textAutor)}
          </p>
          <div className={css.pidWrap}>
            <p className={css.descP}>
              Фізичні характеристики: {oneProd.priceMas}, {oneProd.pageCount}{" "}
              стр,{oneProd.bookFormat} мм, {oneProd.ilystracii},{" "}
              {oneProd.booksWei} гр, {oneProd.bookLanguage}, дизайн{" "}
              {oneProd.bDesign}
            </p>
            <p className={css.descP}>Жанр: {oneProd.ganr}</p>
            <p className={css.descP}>Призначення: {oneProd.forWho}</p>
          </div>
        </div>
        <div className={css.powerWrap}>
          <p className={css.power}>Сила</p>
          <p className={css.powerDesc}>{oneProd.bookPower}</p>
          <br />
        </div>
        <p className={css.opusBook}> {oneProd.descriptionSe}</p>
      </div>
    </div>
  );
}
